/**
 * WordPress dependencies
 */
import '../../css/frontend/style.css';

import domReady from '@wordpress/dom-ready';
import initModal from './components/modal';
import initFAQ from './components/yoast-faq';
import vwHack from './components/vw-hack';
import YTEmbed from './components/youtube-embed';
import moveRelatedArticlesBlock from './components/move-related-articles-block';
import GatedLinks from './components/gated';
import OuterLinks from './components/outer-links';
import setupLoggedInMenu from './components/setup-logged-in-menu';
import preventHashlinkScroll from './components/prevent-hashlink-scroll';
import './components/dv-video-player';

domReady(() => {
	initModal();
	initFAQ();
	moveRelatedArticlesBlock();
	GatedLinks();
	preventHashlinkScroll();

	setTimeout(() => {
		OuterLinks();
	}, 500);
});

document.addEventListener('mydavita-logged-in', () => {
	setupLoggedInMenu();
});

vwHack();
YTEmbed.init();
